<template>
  <div
    oncontextmenu="return false"
    oncopy="return false"
    oncut="return false"
    class="content"
    id="titleDetailPage"
    ref="titleDetailPage"
  >
    <div class="title">{{ data.title }}</div>
    <div
      @click="openUrl(data.subtitle)"
      class="subtitle"
      v-if="data.subtitle"
      :class="{
        href:
          data.subtitle.indexOf('http') > -1 ||
          data.subtitle.indexOf('www.') > -1,
      }"
    >
      {{ "——" + data.subtitle }}
    </div>
    <p class="author" v-if="data.userName">作者：{{ data.userName }}</p>
    <p class="time">{{ moment(data.createDate).format("YYYY-MM-DD") }}</p>
    <el-divider></el-divider>
    <div class="text" v-html="data.content"></div>
    <div
      style="padding-top: 30px; padding-left: 20px"
      v-if="data.attachmentList && data.attachmentList.length > 0"
    >
      <p style="margin-bottom: 10px">附件：</p>
      <ul>
        <li
          style="margin-bottom: 10px"
          v-for="(item, index) in data.attachmentList"
          :key="index"
        >
          <a @click="download(item)">{{ item.attachmentTitle }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { autoApi } from "@/api/home";
import moment from "moment";
export default {
  data() {
    return {
      moment,
      url: "",
      pageViewId: "",
      data: {},
    };
  },
  created() {
    this.url = this.$route.query.url;
    this.pageViewId = this.$route.query.pageViewId;
    this.getText();
  },
  methods: {
    openUrl(url) {
      if (url.indexOf("http") == 0 || url.indexOf("www.") == 0) {
        window.open(url);
      }
    },
    getText() {
      autoApi(this.url, { id: this.pageViewId }).then((res) => {
        console.log(res);
        this.data = res;
      });
    },
    download(item) {
      window.open("/attachmentDir/" + item.filesName);
    },
  },
};
</script>
<style>
</style>
<style lang="less" scoped>
.content {
  margin: -20px;
  background: url("~@/assets/img/pageBg.png") no-repeat !important;
  padding: 20px;
  .title {
    text-align: center;
    padding-top: 30px;
    margin-bottom: 20px;
    font-size: 25px;
  }
  .subtitle {
    margin-bottom: 15px;
    font-size: 16px;
    text-align: center;
  }
  .href {
    text-decoration: underline;
    cursor: pointer;
    color: #666;
  }
  .href:hover {
    color: inherit;
  }
  .author {
    text-align: center;
    font-size: 12px;
    margin-bottom: 5px;
  }
  .time {
    text-align: center;
    font-size: 12px;
    margin-bottom: 20px;
  }
  .text {
    padding: 20px;
    /deep/img {
      max-width: 100% !important;
    }
  }
}
</style>